
<div *ngIf="processing">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h2>LOADING</h2>
  </div>
</div>

<div *ngIf="!processing">
    <div class="m-b-16 flex flex-row gap-2 justify-start items-center">
      <span>Online payment duplicate detected</span>
    </div>

    <mat-card class="note" *ngIf="isValid">
      <span >The payment processing system has detected a <strong>Duplicate</strong> payment. <br/><br />      
        <ul>
          <li>Please contact the appropriate team via the <strong><a [routerLink]="['/messages']" >Messaging System</a></strong> to look into the issue.  </li>
        </ul>
      </span>
    </mat-card>
  </div>

